import React from 'react';

const TokenPricing = () => (
  <div className="token-box" aria-label="Token pricing">
    <div style={{ fontWeight:600, marginBottom:6 }}>Token Pricing</div>
    <ul className="plan-features" style={{ marginTop:0 }}>
      <li>$5 → $5 in tokens</li>
      <li>$25 → $30 in tokens (20% bonus!)</li>
      <li>$50 → $65 in tokens (30% bonus!)</li>
    </ul>
  </div>
);

export default TokenPricing;


